import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import api from "@/lib/api";
import { useI18n } from "@/i18n";

export default function Onboarding() {
  const { t } = useI18n();
  const nav = useNavigate();
  const [step, setStep] = useState(0);
  const steps = [
    { title: t("onboard.1t"), body: t("onboard.1b") },
    { title: t("onboard.2t"), body: t("onboard.2b") },
    { title: t("onboard.3t"), body: t("onboard.3b") },
    { title: t("onboard.4t"), body: t("onboard.4b") },
  ];

  const finish = async () => {
    try { await api.post("/account/onboarded"); } catch {}
    nav("/dashboard");
  };

  const next = () => { step < steps.length - 1 ? setStep(step + 1) : finish(); };

  return (
    <div className="min-h-screen bg-void flex flex-col" data-testid="onboarding">
      <div className="px-6 md:px-12 h-16 flex items-center justify-between">
        <span className="font-serif text-2xl text-ink">AI Lernwerk</span>
        <button onClick={finish} className="text-sm text-ink-muted hover:text-ink transition-colors" data-testid="onboarding-skip">
          {t("onboard.skip")}
        </button>
      </div>
      <div className="flex-1 flex items-center justify-center px-6">
        <div className="max-w-xl w-full">
          <AnimatePresence mode="wait">
            <motion.div key={step}
              initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.5 }}>
              <div className="text-gold text-sm tracking-[0.3em] mb-6">0{step + 1} / 0{steps.length}</div>
              <h1 className="font-serif text-5xl text-ink mb-6 leading-tight">{steps[step].title}</h1>
              <p className="text-ink-soft text-lg leading-relaxed">{steps[step].body}</p>
            </motion.div>
          </AnimatePresence>
          <div className="flex items-center gap-3 mt-12">
            {steps.map((_, i) => (
              <div key={i} className={`h-1 flex-1 transition-colors ${i <= step ? "bg-gold" : "bg-ink/10"}`} />
            ))}
          </div>
          <button onClick={next} data-testid="onboarding-next"
            className="mt-10 bg-gold text-void px-8 py-3 font-medium hover:bg-gold-hover transition-colors">
            {step < steps.length - 1 ? t("onboard.next") : t("onboard.start")}
          </button>
        </div>
      </div>
    </div>
  );
}
